import React from 'react'

import CommunitySection from '../components/CommunitySection'
import FeaturesSection from '../components/FeaturesSection'
import FomoSection from '../components/FomoSection'
import HeroSection from '../components/HeroSection'

const CollegeLandingPage = () => {
  return (
    <div className="flex flex-col gap-y-12 px-6 sm:px-8 lg:px-10 mt-8 md:mt-0">
      <HeroSection />
      <FeaturesSection />
      <CommunitySection />
      <FomoSection />
    </div>
  )
}

CollegeLandingPage.seo = {
  title: 'School Community | Devsnest',
  description:
    'Devsnest School Community Helps us choose the right tech college, provides you with mentorship and guidance via industry professionals from top tech companies'
}

export default CollegeLandingPage
